async function loadCategoryGalleriesToMinicart(data,shopifyCartJson){
    if (data != undefined) {
      var categoryGalleries = data.Data;
      if(categoryGalleries.length>0){
        var cartDoorStyles=new Set(shopifyCartJson.flatMap(i=>i.properties._ideal_doorstyle?.toString().length>0?[i.properties._ideal_doorstyle]:[]));
        var miniCartHTML="";
        const shopifyImage_PlaceHolder="//costco.weatherstrong.com/cdn/shop/files/shopify-image-place-holder.jpg?v=15976";
        for (const doorStyle of cartDoorStyles) {
         var galleries=categoryGalleries.filter(c=>c.ExtensionData.toLowerCase()==doorStyle.toLowerCase());
         for (const gallery of galleries) {
          miniCartHTML+=`
            <div class="row cart-door">
              <div class="col-xs-3 text-center">
                  <a href="/collections/${gallery.SEName}">
                      <img loading="lazy" class="img-responsive" src="${shopifyImage_PlaceHolder.replace("shopify-image-place-holder.jpg",gallery.ExtensionData+".jpg")}">
                  </a>
              </div>
              <div class="col-xs-9 text-left">
                  <div class="text - uppercase Lato - Black " style="letter - spacing: 2px; margin - bottom: 10px; font-size:20px; ">${gallery.NameDescription}</div>
                  <p class="Lato-Regular">
                      <span class="text-uppercase t12 Lato-Black">Construction: </span>${gallery.construction}
                      <br>
                      <span class="text-uppercase t12 Lato-Black">Box Material: </span>${gallery.boxMaterial}
                      <br>
                      <span class="text-uppercase t12 Lato-Black">Door Material: </span>${gallery.doorMaterial}
                      <br>
                      <span class="text-uppercase t12 Lato-Black">Assembled: </span>${gallery.isAssembled}
                      <br>
                      <span class="text-uppercase t12 Lato-Black">Features: </span>${gallery.features}
                  </p>
              </div>
            </div>`;
         }
        }
        if($("#minicart-content").html()!=undefined){          
          $("#minicart-content").html(miniCartHTML);
        }else{          
          $("#ajaxminicartcontents").html(`
          <div class="dropdown-menu pull-right mini-cart-down" aria-labelledby="dropmicartcontents">
            <input type="hidden" id="minicartqty_hidden" value="">
            <button type="button" class="close pull-left" aria-hidden="true"></button>
            <div class="clr"></div>
            <div class="mini-cart-inner">
                <div class="title">Shopping Cart</div>
                <div class="Lato-Italic t17 gray text-left">
                    Delivered (after discount): <span class="LatoBoldItalic p_red" id="minicart_totalprice"></span>
                </div>
                <div class="Lato-Italic gray text-left">
                    <span>*While Supplies Last</span>
                </div>
                <button class="btn btn-white" onclick="javascript:window.location.href='/cart';" type="button">
                    <span>Cart Details</span>
                    <i class="fa fa-angle-right"></i>
                </button>
                <br>
                <br>
                <div id="minicart-content">
                ${miniCartHTML}
                </div>              
            </div>
          </div>`);
        }
      }
    }
  }